import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

export const APPLICATION_PARTICIPANTS_REQUEST = 'FETCH_APPLICATION_PARTICIPANTS_REQUEST';
export const APPLICATION_PARTICIPANTS_FAILURE = 'FETCH_APPLICATION_PARTICIPANTS_FAILURE';
export const APPLICATION_PARTICIPANTS_SUCCESS = 'FETCH_APPLICATION_PARTICIPANTS_SUCCESS';

export const fetchApplicationParticipantReport = (application) => {
    return function(dispatch) {
        dispatch(fetchRequest());

        return axios(apiRequestOptions(apiPath.REPORTS.APPLICATION_PARTICIPANTS, null, {
            params: {id: application.id},
            isBlob: true,
        }))
            .then(transformHttpResponse)
            .then(response => {
                const content = response.headers['content-type'];
                const contentDisposition = response.headers['content-disposition'] || '';
                const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
                const filename = filenameMatch ? filenameMatch[1] : 'report.pdf';
                download(response.data, filename, content);
                dispatch(fetchSuccess());
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => ({type: APPLICATION_PARTICIPANTS_REQUEST});

const fetchFailure = error => ({type: APPLICATION_PARTICIPANTS_FAILURE, error,});

const fetchSuccess = () => ({type: APPLICATION_PARTICIPANTS_SUCCESS});
